import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import {IsActive, IsLoading} from "../../data";


export const Root = styled.section<IsLoading & IsActive>`
    position: relative;
    font-family: 'LatoWeb', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: var(--color-accent);
    min-width: 320px;
    background-color: var(--color-accent-reversed);
    box-sizing: border-box !important;

    ${device.less1180} {
        font-size: 14px;
    }

    ${device.less768} {
        font-size: 12px;

        ${(props) => props.$isActive && css`
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
        `}
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.5);
        display: block;
        pointer-events: none;
        opacity: 0.0001;
        transition: opacity 0.3s;
        z-index: 1800;

        ${(props) => (props.$isLoading) && css`
            opacity: 1;
            pointer-events: auto;
        `}
    }


`;

export const Wrap = styled.div`
    width: 100%;
`;

export const Container = styled.div`
    width: 100%;
    display: grid;
    gap: 0 40px;
    grid-gap: 0 40px;
    grid-template-columns: calc(100% - 600px - 40px) 600px;
    
    ${device.less1400} {
        gap: 0 40px;
        grid-gap: 0 40px;
        grid-template-columns: calc(100% - 500px - 40px) 500px;
    }
    
    ${device.less1180} {
        grid-template-columns: auto 380px;
    }
    
    ${device.less768} {
        display: flex;
        flex-direction: column;
        position: relative;
    }
`;

export const Head = styled.div<IsActive>`
    grid-column: 2;
    grid-row: 1;
    transition: transform 0.5s ease-out;

    ${device.less768} {
        padding: 15px;

        ${(props) => props.$isActive && css`
            transform: translateY(-100%);
        `}
    }
`;

export const Body = styled.div`
    grid-column: 1;
    grid-row: 1 / 3;
    min-height: 80vh;
`;

export const Foot = styled.div`
    grid-column: 2;
    grid-row: 2;
    
    ${device.less768} {
        position: sticky;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        flex: 0 0 100%;
        display: flex;
        flex-direction: column;
        z-index: 400;
        background-color: #fff;
    }
`;

export const RandomContainer = styled.div`
    display: none;

    ${device.less768} {
        display: block;
        position: absolute;

        top: -110px;
        left: 15px;
    }
`;

export const Overlay = styled.div<IsActive>`
    ${device.less768} {
        width: 100%;
        height: 100%;
        background-color: transparent;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 200;
        opacity: 0.0001;
        transition: opacity 0.5s ease-out;
        pointer-events: none;
        
        ${(props) => props.$isActive && css`
            opacity: 1;
            pointer-events: auto;
        `}
    }
`;
